module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('h1', {
    staticClass: "hilight-color mg-lg"
  }, [_c('span', {
    staticClass: "ion ion-ios-people"
  }), _c('strong', [_vm._v("  Lisää toimittajia")])])]), _vm._v(" "), _c('v-alert', [_vm._v("\n              Tähän kenttään voitte lisätä haluamasi alihankkijoiden sähköpostit erotettuna pilkulla.               \n          ")]), _vm._v(" "), _c('input-tag', {
    attrs: {
      "placeholder": "Erottele sähköpostit pilkulla",
      "validate": "email",
      "on-change": _vm.callbackMethod,
      "tags": _vm.tagsArray,
      "read-only": false
    }
  }), _vm._v(" "), _c('v-nav-footer', {
    attrs: {
      "prevRoute": "bids-open.index",
      "nextRoute": "inner-basics.index",
      "routeParams": {
        projectId: _vm.$store.state.route.params.projectId
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-35212bf7"}!./src/app/pages/bidders/bidders.html
// module id = 469
// module chunks = 1